<template>
    <div :class="{section: true, trip: true, mobile: mobile()}">
        <img class="hill hill1" src="@/assets/christmas/redHill.svg">
        <img class="hill hill2" src="@/assets/christmas/redHill.svg">
        <img class="grass" src="@/assets/christmas/grass.svg">
        <img class="couple" src="@/assets/christmas/walkingCouple.svg">
        <img class="moon" src="@/assets/christmas/moon.svg">
        <div class="ground"></div>
        <p class="text">Josef zieht mit Maria, seiner schwangeren Frau, wegen einer Volkszählung in seinen Herkunftsort Bethlehem.</p>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import BasicComponent from "@/components/BasicComponent";

    @Component()
    export default class Trip extends BasicComponent {

        onActive() {

        }

        mounted() {
            this.register();
        }



    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/Christmas.scss";

    $mobileGroundHeight: 40vh;

    .trip {

        position: relative;
        background-color: white;

        .grass {
            max-height: 8vh;
            max-width: 5vw;

            position: absolute;
            bottom: $groundHeight;
            left: 20%;
            transform: translateX(-50%);
        }

        .couple {
            height: 20vh;
            max-width: 50vw;
            position: absolute;
            bottom: $groundHeight;
            right: 30%;
            transform: translateX(50%);
        }

        .moon {
            height: 10vh;
            max-width: 50vw;
            min-height: 80px;
            position: absolute;
            top: 15vh;
            right: 15%;
            transform: translate(50%, -50%);
        }

        .text {
            text-align: left;
            width: 300px;
            max-width: 35vw;
            position: absolute;
            top: 25vh;
            left: 15%;
            font-weight: normal;
            font-size: 1.6em;
            color: black;
        }

    }

    .mobile {

        .grass {
            bottom: $mobileGroundHeight;
        }

        .couple {
            bottom: $mobileGroundHeight;
        }

    }

</style>
